import mixpanel from 'mixpanel-browser';

const mixpanelToken = '46be4d299db10ac82b42ac6d28eca59b'
const appVersion = process.env.REACT_APP_APP_VERSION || null;

const TrackerService = {
    logIn: function(user_id, params = {}) {
        if(process.env.NODE_ENV === 'production') {
            mixpanel.init(mixpanelToken);
            mixpanel.identify(user_id)
            mixpanel.people.set({ ...params, app_version: appVersion });
            mixpanel.track('Inicio sesion');
        }
    },

    track: function(event, params = {}) {
        if(process.env.NODE_ENV === 'production'){
        mixpanel.init(mixpanelToken);
        mixpanel.track(event, { ...params, app_version: appVersion });
        }
    }
}

export default TrackerService